/// <amd-module name="SuiteCommerce.GridOrder.MatrixItemOption.View"/>
define("SuiteCommerce.GridOrder.MatrixItemOption.View", ["require", "exports", "underscore", "SuiteCommerce.GridOrder.Configuration", "grid_order_cell_matrix_item_option.tpl"], function (require, exports, _, GridOrder_Configuration_1, matrixItemOptionTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MatrixItemOptionViewPrototype = /** @class */ (function () {
        function MatrixItemOptionViewPrototype() {
        }
        Object.defineProperty(MatrixItemOptionViewPrototype.prototype, "template", {
            get: function () {
                return matrixItemOptionTemplate;
            },
            enumerable: true,
            configurable: true
        });
        MatrixItemOptionViewPrototype.prototype.isColor = function () {
            var _this = this;
            var tableDisplayOptions = GridOrder_Configuration_1.GridOrderConfiguration.tableDisplayOptions;
            var displayOption = _.find(tableDisplayOptions, function (displayOption) {
                return displayOption.itemFieldID === _this.model.customItemFieldId;
            });
            return !!displayOption;
        };
        MatrixItemOptionViewPrototype.prototype.getColorValue = function () {
            var _this = this;
            var tableDisplayOptions = GridOrder_Configuration_1.GridOrderConfiguration.tableDisplayOptions;
            var colorPalette = GridOrder_Configuration_1.GridOrderConfiguration.colorPalette;
            var displayOption = _.find(tableDisplayOptions, function (displayOption) {
                return displayOption.itemFieldID === _this.model.customItemFieldId;
            });
            if (displayOption) {
                var color = _.find(colorPalette, function (color) {
                    return color.paletteId === displayOption.paletteId && color.colorName === _this.model.label;
                });
                if (color)
                    return color.colorValue;
            }
            return '';
        };
        MatrixItemOptionViewPrototype.prototype.getContext = function () {
            return {
                label: this.model.label,
                showAsColor: !!(this.isColor() && this.getColorValue()),
                colorValue: this.getColorValue(),
                isWhiteColor: this.model.label === 'white',
            };
        };
        return MatrixItemOptionViewPrototype;
    }());
    exports.MatrixItemOptionViewPrototype = MatrixItemOptionViewPrototype;
});
